// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "0b9d6a1";
